import ContentEditor from '@/jquery/widgets/contentEditor'

(function ($) {
    $.Redactor.prototype.salesforce = function () {
        return {
            init: function () {
                var $button = this.button.add('salesforce', "Salesforce");
                this.button.setIcon($button, '<i class="icon iconp-salesforce"></i>');
                new ContentEditor(
                    this.$box, {
                        wysiwyg: 'redactor',
                        salesforce: true,
                        salesforceButton: $button
                    });
            }
        };
    };
})(jQuery);



//////////////////
// WEBPACK FOOTER
// ./vendor/redactor2/custom-plugins/salesforce.js
// module id = Ivl3
// module chunks = 40